import gql from 'graphql-tag';

export default gql`
	query CloudUser($userId: String!, $cloudId: String) {
		CloudUser(userId: $userId, cloudId: $cloudId) {
			id
			fullName
			avatarUrl
			email
			timezone
			locale
			title
			location
			companyName
			department
			statusModifiedDate
			isNotMentionable
			phoneNumber
		}
	}
`;
